import EfImg from '@elem/ui/ef-img';
import EfLink from '@elem/ui/ef-link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import css from './modal.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfModal from '@/components/UI/Modal';

const ICON_COLSE = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 5L5 15" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 5L15 15" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export function ModalLeave({ open, onCancel, onOk }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('supportcasecreate');

    const ICON = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
            <circle cx="25" cy="25" r="25" fill="#F7A40A" />
            <path
                d="M23.812 30.288L22.948 16.32L22.84 12.072H27.16L27.088 16.32L26.188 30.288H23.812ZM25 39.18C23.416 39.18 22.12 38.1 22.12 36.336C22.12 34.644 23.416 33.528 25 33.528C26.584 33.528 27.88 34.644 27.88 36.336C27.88 38.1 26.584 39.18 25 39.18Z"
                fill="white"
            />
        </svg>
    );

    return (
        <EfModal
            className={`modal-leave ${css.modalleave}`}
            open={open}
            visible={open}
            width={450}
            onCancel={onCancel}
            zIndex={9999}
            onOk={onOk}
            closeIcon={<ICON_COLSE />}
        >
            <div className="content">
                <ICON />
                <h1 className="title">{t('modal_leave_title')}</h1>
                <p className="desc">{t('modal_leave_desc')}</p>
                <div className="btn-group">
                    <button className="cancel" onClick={onCancel}>
                        {t('modal_cancel')}
                    </button>
                    <button className="confirm" onClick={onOk}>
                        {t('modal_confirm')}
                    </button>
                </div>
            </div>
        </EfModal>
    );
}

export function ModalLimit({ open, onCancel }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('supportcasecreate');
    const { locale = 'us' } = useRouter();

    return (
        <EfModal
            className={`modal-limit ${css.modallimit}`}
            open={open}
            visible={open}
            width={320}
            onCancel={onCancel}
            zIndex={9999}
            closable={false}
            closeIcon={<ICON_COLSE />}
        >
            <div className="content">
                <p className="desc">{t('modal_limit_desc')}</p>
                <EfLink className="link sure" href={`/${locale}/support`}>
                    {t('modal_sure')}
                </EfLink>
            </div>
        </EfModal>
    );
}

export function ModalImage({ open, onCancel, title, url }: any) {
    const [suffix, setSuffix] = useState('');
    const video = ['mp4', 'webm', 'avi'];
    const img = ['jpeg', 'png', 'jpg'];

    useEffect(() => {
        setSuffix(url.split('.').pop());
    }, [url]);

    return (
        <EfModal
            className={`modal-preview ${css.modalpreview}`}
            open={open}
            title={title}
            visible={open}
            width={600}
            onCancel={onCancel}
            zIndex={9999}
            closable={false}
            closeIcon={<ICON_COLSE />}
        >
            {img.includes(suffix) && <EfImg className="preview" pc={url} />}
            {video.includes(suffix) && (
                <video
                    className="preview-video"
                    muted
                    autoPlay
                    loop
                    playsInline
                    // eslint-disable-next-line react/no-unknown-property
                    webkit-playsinline="true"
                    // eslint-disable-next-line react/no-unknown-property
                    x5-playsinline="true"
                    // eslint-disable-next-line react/no-unknown-property
                    x5-video-player-type="h5-page"
                    src={url}
                />
            )}
        </EfModal>
    );
}
